module.exports = __webpack_public_path__ + "img/link.7ba9beb2.svg";